import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Row, Col, Popover, OverlayTrigger } from 'react-bootstrap';
import { HelpIcon } from 'components/atoms/HelpIcon';
import { generateLabelCodePreview } from 'helpers/labelCode';
import InputTip from 'components/atoms/form/InputTip';
import SelectObjectiveList from 'components/atoms/inputs/SelectObjectiveList';
import styled from 'styled-components';
import TextInputAdmin from 'components/atoms/inputs/TextInputAdmin';
import CheckBoxSelect from 'components/atoms/form/CheckBoxSelect';
import StyledLabel from 'components/atoms/inputs/Label';
import FormSectionHeading from 'components/atoms/form/FormSectionHeading';
import ProtectedComponent from 'hoc/ProtectedComponent';
import { DisabledDiv, HiddenBorderDiv, HiddenDiv } from 'components/atoms/form/UtilityDivs';
import { SPEND_MARKUP_VIEW, MANAGE_ENTITY_OBJECTIVE, ENTITY_OBJECTIVE_LABELCODE_EDIT } from 'constants/capabilities';

const FlexWrapper = styled.div`
    display: flex;
    align-items: center;
`;

const labelCodeHelpText = (<Popover
    id="labelcode-help-text"
    placement="right"
    title="Label Codes"
>
    The label entered in this field will replace the default text used for eCPA objective
    reporting (i.e. eCPA Activities). This will NOT affect the data loaded in any way.
</Popover>);

const spendMarkupTipText = [
    'This will increase all spend calculations in the dashboard by the ',
    '% entered (i.e. enter 5 for 5%). Useful for 3rd parties (i.e. agencies) ',
    'to seamlessly show their markup (in addition to Goodway\'s margin, ',
    'which is already included).'
].join('');

const SpendMarkupProtectedComponent = ProtectedComponent({
    requiredCapabilities: [SPEND_MARKUP_VIEW]
})(props => (<React.Fragment>{props.children}</React.Fragment>));

const EntityObjectiveProtectedComponent = ProtectedComponent({
    requiredCapabilities: [MANAGE_ENTITY_OBJECTIVE]
})(props => (<React.Fragment>{props.children}</React.Fragment>));

const EntityObjectiveLabelCodeProtectedComponent = ProtectedComponent({
    requiredCapabilities: [ENTITY_OBJECTIVE_LABELCODE_EDIT]
})(props => (<HiddenDiv hide={!props.showLabelCodeInput}>{props.children}</HiddenDiv>));

const shouldRenderDisplayConfigurationOverlay = (props) => {
    if (props.selectedBrandId) {
        return !props.selectOverrideBrandDisplayConfiguration;
    }
    return false;
};

const DisplayConfiguration = (props) => {
    const { selectedBrandId, selectedProgrammaticObjective, selectedLabelCode } = props;
    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    <FormSectionHeading>Display Configuration</FormSectionHeading>
                </Col>
            </Row>
            <SpendMarkupProtectedComponent>
                <Row>
                    <Col xs={12}>
                        <StyledLabel>Spend Markup</StyledLabel><br />
                    </Col>
                    <Col xs={12} md={6}>
                        <Field component={TextInputAdmin} name="meta.spendMarkup.value" type="number" autocomplete="nope" inputGroupTextAppend="%" />
                        <Field component={TextInputAdmin} name="meta.spendMarkup.type" type="text" autocomplete="nope" hidden />
                        <InputTip marginBottom="10px">{spendMarkupTipText}</InputTip>
                    </Col>
                </Row>
            </SpendMarkupProtectedComponent>
            <EntityObjectiveProtectedComponent>
                <Row>
                    <Col xs={12}>
                        <StyledLabel>Objective Settings</StyledLabel><br />
                    </Col>
                    <Col xs={12} md={6}>
                        <Field name="meta.programmaticObjective.global" component={SelectObjectiveList} />
                    </Col>
                </Row>
                <EntityObjectiveLabelCodeProtectedComponent showLabelCodeInput={!selectedProgrammaticObjective || selectedProgrammaticObjective === 'ecpa'}>
                    <HiddenBorderDiv hide={!selectedBrandId}>
                        {props.selectedBrandId ? (
                            <Field
                                name="meta.overrideBrand.objectiveLabel"
                                label="Override Brand Custom eCPA Label"
                                type="checkbox"
                                component={CheckBoxSelect}
                                // overlay={overrideBrandAdvancedlHelpText}
                            />
                        ) : null}
                        <DisabledDiv sm={6} disablePointer={shouldRenderDisplayConfigurationOverlay(props)}>
                            <Row>
                                <Col xs={12}>
                                    <FlexWrapper>
                                        <StyledLabel>Custom eCPA Label</StyledLabel>
                                        <OverlayTrigger trigger="click" placement="right" overlay={labelCodeHelpText}>
                                            <HelpIcon padding={'1px'} />
                                        </OverlayTrigger>
                                        <br />
                                    </FlexWrapper>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Field
                                        name="meta.programmaticObjective.labelCode"
                                        autocomplete="nope"
                                        placeholder={'E.g. Leads, Sales, Activities, etc.'}
                                        required={false}
                                        component={TextInputAdmin}
                                    />
                                    <InputTip marginBottom="10px">{generateLabelCodePreview(selectedLabelCode)}</InputTip>
                                </Col>
                            </Row>
                        </DisabledDiv>
                    </HiddenBorderDiv>
                </EntityObjectiveLabelCodeProtectedComponent>
            </EntityObjectiveProtectedComponent>


        </React.Fragment>
    );
};

DisplayConfiguration.propTypes = {
    selectedBrandId: PropTypes.number,
    selectedLabelCode: PropTypes.string,
    selectedProgrammaticObjective: PropTypes.string,
    selectOverrideBrandDisplayConfiguration: PropTypes.bool
};


export default DisplayConfiguration;



// WEBPACK FOOTER //
// ./src/components/organisms/entity/edit/DisplayConfiguration.js